import 'angular-modal-service';
import * as MixpanelDashboard from '../../react/infra/mixpanel/MixpanelDashboard';

var dashboardModule = angular.module(__filename, [
    'angularModalService',
    require("widgets/brand-index/brand-index-widget").name,
    require("widgets/geo-widget/geo-widget").name,
    require("widgets/brand-perceptions-widget/brand-perceptions-widget").name,
    require("widgets/audience-widget/audience-widget").name,
    require("widgets/news-widget/news-widget").name,
    require("widgets/rt-associations-widget/rt-associations-widget").name,
    require('pages/programs/program_settings/program-settings').name,
]);

function buildDashboardTerms(TermsMold, context) {
    if (!context.program.brand.name) return Promise.resolve([]);
    var mold = new TermsMold(context.current);
    return mold.replace([context.program.brand.name].concat(context.program.competitors.map(function (c) {
        return c.name;
    }).sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    }))).then(function () {
        return mold._value;
    });
}

buildDashboardTerms.$inject = ["TermsMold", "context"];
function DashBoardController($scope, topicsTree, TermsMold, context, dashboard_terms, ModalService, programService) {
    $scope.filterMenuOpen = $scope.$root.filterMenuOpen;
    $scope.timeframe = 30;
    $scope.topics = topicsTree.topics;
    $scope.dashboard_terms = dashboard_terms;
    $scope.$watch("context.program", function () {
        buildDashboardTerms(TermsMold, context).then(function (value) {
            $scope.dashboard_terms = value;
            openProgramIfEmpty();
            MixpanelDashboard.trackDashboardSearch();
        });
    });
    $scope.$watch("$root.filterMenuOpen", function (isOpen) {
        $scope.filterMenuOpen = isOpen;
    });

    var closeListener = context.onChange(MixpanelDashboard.trackDashboardSearch);
    $scope.$on('$destroy', closeListener);
    MixpanelDashboard.trackPageView();

    function openProgramIfEmpty() {
        if ($scope.dashboard_terms.length == 0) {
            programService.program(context.program.id).then(function (program) {
                ModalService.showModal({
                    template: require('pages/programs/program_settings/program-settings.html'),
                    inputs: {program: program, initialView: 'dashboard interests'},
                    controller: 'programSettingsController'
                }).then(function(modal){
                    // Expose hook for e2e to target the modal root
                    try {
                        const el = document.querySelector('.ngdialog, [role="dialog"]');
                        if (el) el.setAttribute('data-test-id', 'program-modal');
                    } catch (e) {}
                });
            });
        }
    }
}

DashBoardController.$inject = ["$scope", "topicsTree", "TermsMold", "context", "dashboard_terms", "ModalService", "programService"];

dashboardModule.stateConfig = {
    name: "dashboard",
    url: "/dashboard",
    template: require("./dashboard.html"),
    display: "Dashboard",
    controller: DashBoardController,
    resolve: {
        dashboard_terms: buildDashboardTerms
    },
    data: {
      permissions: ['dashboard']
    },
    context: {}
};

export default dashboardModule;
